export const MolarTeeth: number[] = [1, 2, 3, 14, 15, 16, 32, 31, 30, 19, 18, 17];
export const SecondPremolarTeeth: number[] = [4, 13, 29, 20];
export const FirstPremolarTeeth: number[] = [5, 12, 28, 21];
export const UpperTeethDivider: number = 16;
export const LowerTeethDivider: number = 17;
export const UpperPosteriorsTeeths: number[] = [6, 7, 8, 9, 10, 11];
export const LowerPosteriorsTeeths: number[] = [27, 26, 25, 24, 23, 22];
